export enum TOOL_STATUS_NAME {
    AVAILABLE = 'Disponible',
    BUY_BACK = 'Buy Back',
    SOLD_TO_THIRD_PARTY = 'Vendida a tercero',
    LOST = 'Perdida',
    DONATED = 'Donada',
    DAMAGED = 'Dañada',
    DESTROYED = 'Destruida',
    OUTBOUND_SHIPMENT = 'Salida outbound',
    WAREHOUSE = 'Bodega',
    WARRANTY = 'Garantia',
    DIAGNOSTIC = 'Diagnostico',
    IN_MOVEMENT = 'En movimiento',
}